import {ProgressTrack, trackRatio, useProgressReveal} from '@/components/ProgressTrack';
import experienceScoreStatuses, {isPositiveStatus} from '@/consts/experienceScore/experienceScoreStatuses';

const MAX_PERCENTAGE = 100;

interface ScoreBarProps {
    value: number;
    status?: string;
    labelledBy?: string;
    className?: string;
}

const ScoreBar = ({value, status = experienceScoreStatuses.OPTIMAL, labelledBy, className}: ScoreBarProps) => {
    const percentage = Math.min(Math.max(value, 0), MAX_PERCENTAGE);
    const ratio = useProgressReveal(trackRatio(percentage, MAX_PERCENTAGE));

    return (
        <ProgressTrack
            ratio={ratio}
            value={percentage}
            max={MAX_PERCENTAGE}
            isPositive={isPositiveStatus(status)}
            labelledBy={labelledBy}
            className={className}
        >
            {percentage}
        </ProgressTrack>
    );
};

export default ScoreBar;
